import { AfterViewInit, Component, OnInit } from '@angular/core';
import { StatisticService } from 'src/app/services/statistic.service';
import { AnalyticDataSource } from 'src/app/services/analytic.datasource';

@Component({
  selector: 'app-data-validation',
  templateUrl: './data-validation.component.html',
  styleUrls: ['./data-validation.component.css'],
})
export class DataValidationComponent implements OnInit, AfterViewInit {
  public noDataAvailable: boolean = false;
  dataSource: AnalyticDataSource = new AnalyticDataSource(
    this.statisticService
  );

  public displayedColumns = [
    'NudgeIdentifier',
    'CheckBox',
    'ClientId',
    'ClientName',
    'ParentGrouping',
    'DueDateStr',
    'CountryOfIncorporation',
    'Revenue',
    'Bucket',
    'ClientType',
    'Analyst',
    'QCReviewer',
    'ClientContactTitle',
    'ClientContactEmail',
    'ClientContactName',
    'CompletionDateStr',
    'InitialOutreachDateStr',
    'ReasonForDescope',
    'Products',
    'RiskScore',
    // 'Status',
    // 'Stage',
    'Aging',
    'Link',
    'NextStage',
    'RowMenu',
  ];

  constructor(public statisticService: StatisticService) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {}

  onAddNewEntry() {}

  onPrint() {}

  onUploadExcel() {}

  changeDisplayedColumns(chips: any) {
    this.displayedColumns = chips;
  }

  handleNoTableData(event: boolean) {
    this.noDataAvailable = event;
  }
}
